import { useEffect, useMemo, useRef } from 'react';
import { ModalContainerViewProps } from '../modalcontainer.type';
import './modalcontainer.scss';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import { ImgImporter } from '../../../ui/imgImporter';

const positionList: any = {
  top: 'positionTop',
  bottom: 'positionBottom',
  left: 'positionLeft',
  right: 'positionRight',
  center: '',
};

export const ModalcontainerView: React.FC<ModalContainerViewProps> = observer(
  ({
    className = '',
    backBtn,
    children,
    closePopup = () => {},
    headerText,
    backBtnInfo = {
      action: () => {},
      visible: true,
    },
    minimized = false,
    canClose = true,
    classNameBody = '',
    positions = ['center', 'center'],
    dynamicWidth = false,
    popupIconUri = '',
  }): JSX.Element => {
    const popupRef = useRef<any>();
    useOnClickOutside(popupRef, () => closePopup(false));

    useEffect(() => {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'unset';
      };
    }, []);

    const memoizedClassNames = useMemo(
      () =>
        positions.reduce(
          (acc, curValue: string) => `${acc} ${positionList[curValue]}`,
          '',
        ),
      [],
    );

    return (
      <div
        className={cn('modalContainerHolder', className, {
          without_shadow:
            positions[0] !== 'center' && positions[1] !== 'center',
        })}
      >
        <div
          className={cn(
            'modalContainer general-gradient-border',
            classNameBody,
            memoizedClassNames,
            {
              sizeSmall: minimized,
              fullWidth: dynamicWidth,
            },
          )}
          ref={popupRef}
        >
          <div
            className={`modalContainerHeader ${
              !headerText && 'without_shadow'
            } ${!headerText?.subTitle && 'without_subtitle'}`}
          >
            {backBtn && (
              <div className="modalAction">
                {backBtnInfo?.visible && (
                  <i
                    className="icon-arrow-left"
                    onClick={() => backBtnInfo.action()}
                  />
                )}
              </div>
            )}
            <div className="modalContainerHeaderContent">
              <p className="modalContainerHeadText">{headerText?.title}</p>
              <p className="modalContainerHeadSubTitle">
                {headerText?.subTitle}
              </p>
              <ImgImporter path={popupIconUri} />
            </div>
            {canClose && (
              <div
                className="modalContainerAction"
                onClick={() => closePopup(false)}
              >
                <i className="icon-close" />
              </div>
            )}
          </div>
          <div
            className={cn('modalContainerBody', {
              warningContainer: !headerText,
            })}
          >
            {children}
          </div>
        </div>
      </div>
    );
  },
);
